exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modelSelect[data-v-4e6ac1dc] div.text {\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.delete-warning[data-v-4e6ac1dc] {\n  font-size: 1rem;\n  color: red;\n}\n.card[data-v-4e6ac1dc] {\n  background: #ebeff3;\n  border-radius: 10px;\n}\n.card-header[data-v-4e6ac1dc] {\n  background: #f7f7f7;\n}\n.temp_mapping[data-v-4e6ac1dc] {\n  background: #f8f9fa;\n  padding: 0.5rem;\n  margin: 0;\n}\n.external-service-modal .row[data-v-4e6ac1dc] {\n  margin-bottom: 7px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e6ac1dc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/externalServiceValidations.vue
// module id = 1350
// module chunks = 2